export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "Žádné záznamy",
    "notifications.rp_has_been_updated": "Rezidenční projekt aktualizován",
    "moduleTitle.files": "Soubory",
    "label.coordinator": "Koordinátor",
    "sidebar.translations_managment": "",
    "table.file": "Soubor",
    "label.report_overview": "",
    "label.parent_agreement": "Souhlas rodiče/opatrovníka",
    "parentalConsent.i_consent_to_and_understand_that": "6. Souhlasím a rozumím tomu, že účastníci, kteří se účastní určitých činností souvisejících s DofE, mohou být fotografováni nebo natáčeni, a tyto fotografie/videa mohou být použity pro propagační účely za předpokladu, že účastník a jejich rodiče / opatrovník podepsali příslušný formulář GDPR.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Uvědomuji si, že účastníci jsou povinni dodržovat požadavky a podmínky programu DofE obsažené v záznamové knize nebo v ORB, zásady a standardy chování příslušného místního centra DofE (v platném znění) a požadavky Místního centra ve vztahu k nouzovým plánům, hodnocením aktivit a vedení dobrodružných expedic souvisejících s DofE. Místní centrum může ukončit účastníkovu účast v DofE v případě nerespektování těchto podmínek.",
    "table.end_date": "Konec",
    "label.activation_date": "Datum aktivace",
    "label.report": "",
    "label.award_is_offline": "Cena je nedostupná",
    "label.pending_changes": "Čekající změny",
    "errors.min_nights_required": "Je potřeba zadat minimální počet nocí",
    "label.country": "Země",
    "notifications.award_leader_has_been_returned": "Vedoucí byl opraven",
    "notifications.participant_has_been_updated": "Účastník aktualizován",
    "label.phone_number": "Telefonní číslo",
    "roles.aj_assessor": "Hodnotitel expedice",
    "notifications.person_state_has_been_changed": "Stav kontaktu byl změněn.",
    "pageTitle.dashboard": "Úvodní deska",
    "moduleTitle.global_payment_method": "Globální platební metoda",
    "label.organization_type": "Typ organizace",
    "button.account_settings": "Nastavení účtu",
    "notifications.contact_has_been_updated": "Kontakt aktualizován",
    "participant.recover_password": "Obnovit heslo",
    "notifications.assessment_request_has_been_sent": "Žádost o zhodnocení odeslána",
    "button.unassign": "",
    "OTHER.PERSEVERANCE_APPRENTICE_DESC": "{weekBlock} týdny v kuse.",
    "label.start_date": "Začátek",
    "label.assign_labels": "Přiřaď štítky",
    "sidebar.participants": "Účastníci",
    "roles.coordinator": "Koordinátor",
    "label.organization_contact": "Kontakt organizace",
    "tabs.customization": "Nastavení",
    "sidebar.award_units": "Místní centra",
    "button.change_goal": "Změnit cíl",
    "translationsManagement.selectProject": "Vyberte projekt",
    "award.rp": "Rezidenční projekt",
    "label.size": "Velikost",
    "label.bulk_action_results": "Výsledky hromadné akce",
    "notifications.activity_has_been_approved": "Aktivita byla schválena",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Znovu poslat žádost o zhodnocení",
    "notifications.template_has_been_removed": "Šablona odstraněna",
    "button.award_settings": "Nastavení úrovně",
    "pageTitle.message_center": "Centrum zpráv",
    "pageTitle.payment": "Platba",
    "table.recipient_read_date": "Přečteno",
    "tasks.return_award": "Oprava úrovně",
    "label.link": "odkaz",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "Mé regionální centrum - související kontakty",
    "pageTitle.my_organization_labels": "Moje organizace - Štítky",
    "tabs.activity_signoff": "Schválení oblasti",
    "table.logs": "Záznamy",
    "moduleTitle.remove_file": "Odstranit soubor?",
    "label.email_confirmed": "Email souhlasí (v případě, že jej účastník nepotvrdil sám)",
    "notifications.activity_has_been_returned": "Aktivita byla opravena",
    "label.note": "Poznámka",
    "button.show": "",
    "tabs.adventurous_journey": "Expedice",
    "sidebar.my_todolist": "Můj To Do List",
    "label.here": "tady",
    "organisation.change_award_mode": "Změnit režim účastníka",
    "table.note_from_al": "Poznámka od vedoucího",
    "label.gender": "Pohlaví",
    "moduleTitle.remove": "Odstranit?",
    "errors.must_be_less_than": "Musí být méně než",
    "button.logout": "Odhlášení",
    "label.no_selected_participants": "žádný označený účastník",
    "button.new_aj_event": "Nová expedice",
    "label.employement_status": "Zaměstnání",
    "tabs.logs": "Záznamy",
    "tabs.contacts": "Kontakty",
    "label.option": "Možnost",
    "dashboard.charts": "Žebříčky",
    "notifications.rp_has_been_approved": "Rezidenční projekt schválen",
    "pageTitle.new_participant": "Nový účastník",
    "notifications.award_leader_has_been_approved": "Vedoucí byl schválen",
    "moduleTitle.would_you_like_to_remove_leader_training": "Chcete smazat trénink vedoucího?",
    "moduleTitle.update_configuration_value": "Aktualizovat hodnotu konfigurace",
    "table.description": "Popis",
    "table.organization": "Organizace",
    "label.youtube": "Youtube",
    "CL_BADGE_GROUP_TYPES.PERSEVERANCE": "Vytrvalost",
    "label.author": "Autor",
    "table.suitable_for_award_level": "Vhodné pro úroveň",
    "label.content_update": "Prosím čekejte. Aktualizuji obsah",
    "notifications.new_question_has_been_added": "Nová otázka přidána",
    "pageTitle.nao_awards": "Národní centrum- Úrovně",
    "tabs.new_messages": "Nové zprávy",
    "table.last_name": "Přijmení",
    "moduleTitle.adventurous_journey_detail": "Detaily expedice",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "Hromadné akce"},
    "label.project_location_type": "Lokace projektu",
    "label.email_help_award_level": "",
    "label.date": "Datum",
    "label.previous_completed_award_place": "Kde",
    "button.show_more": "Ukázat více",
    "label.wwc_number": "WWC číslo",
    "button.filter": "Filtrovat",
    "notifications.rp_has_been_returned": "Rezidenční projekt opraven.",
    "pageTitle.residetial_project_assessor_report": "Rezidenční projekt - Zpráva hodnotitele",
    "label.generating": "",
    "moduleTitle.finance_system_data": "",
    "notifications.adventurous_journey_state_has_been_changed": "Stav expedice byl změněn",
    "route.levels": "Úrovně",
    "moduleTitle.activity_leader": "Vedoucí aktivity",
    "tasks.approve_event": "Schválení akce",
    "tasks.reject_event": "Oprava akce",
    "table.region": "kraj",
    "CL_BADGE_SECTION_TYPES.BASIC": "Základní",
    "pageTitle.nao_award_leaders": "Národní centrum- vedoucí",
    "errors.must_be_at_least": "Musí být nejméně (value) znaků",
    "table.title": "Název",
    "table.last_activity": "Poslední aktivita",
    "tasks.delete_registration": "Vymazaná registrace",
    "table.date_time": "Datum / čas ",
    "messages.praise": "Komentář",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Provozovatelé DofE se zavazují respektovat vaše soukromí. Osobní údaje jsou shromažďovány v tomto formuláři za účelem účasti v programu DofE. Účastníci, kteří nám tyto informace neposkytnou, se nemohou účastnit programu DofE. Můžeme také využít vaše osobní údaje k tomu, abychom vám zasílali informace o dalších aktivitách nebo událostech, o kterých se domníváme, že by vás mohly zajímat. Tyto informace můžeme zpřístupnit jiným místním centrům DofE nebo mezinárodnímu centru DofE a poskytovatelům služeb, kteří nám pomáhají při provozování a správě programu DofE. Pokud byste nás chtěli kontaktovat nebo mít přístup k vašim osobním informacím, napište vašemu místnímu centru DofE. Můžete také kontaktovat provozovatele DofE s žádostí o kopii zásad ochrany osobních údajů.",
    "aj.practice_journey": "Cvičná expedice",
    "notification.log_has_been_restored": "Záznam byl obnoven.",
    "tabs.my_participants": "Moji účastníci",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "školitel",
    "moduleTitle.your_parental_consent": "Váš rodičovský souhlas",
    "route.registration_participants": "Registrace účastníků",
    "placeholder.start_typing": "Začít psát...",
    "tasks.approve_award": "Schválení úrovně",
    "route.registrations": "Registrace",
    "button.add_activity": "Přidat aktivitu",
    "notifications.aj_event_has_been_created": "Expedice byla vytvořena",
    "states.supervisor_approval": "Schválení hodnotitele",
    "label.description": "Popis",
    "button.leave_anyway": "I tak opustit",
    "tabs.registrations": "Registrace",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "Překlady byly nahrané",
    "pageTitle.nao_registration": "Národní centrum - registrace",
    "pageTitle.mro_logs": "Mé regionální centrum -  záznamy",
    "OTHER.PERSEVERANCE_DESC": "Chceme Tě odměnit za to, že máš pevnou vůli a DofE se věnuješ pravidelně. Věnuj se své aktivitě každý týden a dostávej za to odznaky v aplikaci ORB.",
    "meta.page_not_found": "Stránka nenalezena",
    "label.bulk_action_unsuccessful": "{count} položek selhalo:",
    "global.days": "Dny",
    "table.review": "Zkontrolovat",
    "moduleTitle.additional_settings": "Další nastavení",
    "table.as_assessor_for": "Hodnotitel pro",
    "roles.if_staff_statistical_user": "IAF Statický uživatel",
    "table.levels": "Úrovně",
    "label.suitable_for_level": "Úroveň expedice",
    "label.see_all_badges": "Všechny odznaky",
    "pageTitle.leaders": "Vedoucí",
    "moduleTitle.send_test_email": "Zaslat testovací email",
    "pageTitle.tasks_removed_registration": "Odstranit registraci účastníka",
    "label.you_will_be_forced_to_login_again_after_change": "Po změně se znovu zaregistrujte",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "Schválení oblasti",
    "pageTitle.payments": "Platby",
    "global.nights": "Noci",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "Vybrat organizaci",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "Nahrát dokumenty",
    "label.migrated_contact_email": "Přesunutý emailový kontakt",
    "label.for_award_unit": "Pro Místní centrum",
    "label.aj_template_note": "Šablona poznámky",
    "table.last_log_added": "Poslední záznam byl přidán",
    "button.view_participant": "",
    "label.please_comment_on_the_participants": "Prosím okomentujte zlepšení/výkon/závazek účastníka.",
    "CL_BADGE_TYPES.PERSEVERANCE": "Vytrvalost",
    "label.consent_already_given_login": "Souhlas už byl udělem. Přihlaste se jako účastník.",
    "participant.level_start_date": "Začátek",
    "sidebar.my_region_office": "Mé regionální centrum",
    "states.section_signoff": "Schválení",
    "moduleTitle.assessor_details": "Detaily hodnotitele",
    "table.message_created_at": "Vytvořeno",
    "moduleTitle.adventurous_journey_settings": "Nastavení expedice",
    "moduleTitle.note_from_al": "Poznámka od vedoucího",
    "button.add_role": "Přidat roli",
    "table.run": "Probíhá",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "Návod k app - vedoucí",
    "tabs.section_approval": "Schválení sekce",
    "roles.award_verifier": "Ověřovatel DofE",
    "tabs.activity_approval": "Schválení aktivity",
    "logs.add_log": "Přidat záznam",
    "tabs.award": "Cena",
    "notifications.this_role_has_read_only_persmission": "Tato role má oprávnění jen pro čtení",
    "table.no_filtered_results": "Žádné vyfiltrované výsledky",
    "button.praise": "Komentář",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "Detail lokality",
    "label.optional": "(libovolný)",
    "errors.do_not_match": "Nesouhlasí",
    "label.use_comma_for_multiple_entries": "",
    "label.operating_authority": "Zastřešující organizace",
    "label.activity_section": "Oblast aktivity",
    "notifications.you_have_been_logged_out": "Byli jste odhlášeni",
    "table.finished": "Dokončeno",
    "button.same_as_billing": "Stejná jako fakturovací",
    "table.payment": "Platba",
    "table.current_level": "Současná úroveň",
    "button.view_nao": "",
    "table.email_confirmation": "Potrvzovací email",
    "moduleTitle.shipping_address": "Doručovací adresa",
    "label.secondary_phone_type": "typ druhého telefonního čísla",
    "notifications.saved": "Uloženo",
    "pageTitle.all_participants": "Všichni účastníci",
    "label.first_name": "Jméno",
    "label.oa_price": "Centrum - cena",
    "table.award_mode": "Mód Ceny",
    "tabs.api_keys": "API klíče",
    "award.award_detail": "Detail ceny",
    "tabs.user_management": "Management uživatele",
    "tabs.all_events": "Všechny akce",
    "notifications.history_record_has_been_removed": "Záznam byl odstraněn",
    "award.no_data": "Žádná data",
    "notifications.preparation_training_has_been_added": "Příprava a trénink přidány",
    "label.message": "Zpráva",
    "notifications.participant_info_updated": "Informace o účastníkovi byly aktualizovány",
    "roles.nao_staff": "Zaměstnanci Národního centra",
    "tabs.adventurous_journeys": "Expedice",
    "label.gops": "",
    "route.upload": "Nahrát",
    "notifications.history_record_has_been_added": "Záznam byl přidán",
    "notifications.history_record_has_been_updated": "Záznam byl aktualizován",
    "label.no_data": "Žádná data",
    "button.add_coordinator": "Přidat koordinátora",
    "label.you_are_already_logged_as": "Již jste přihlášeni jako",
    "route.my_national_office": "Mé Národní centrum",
    "tabs.leaders": "Vedoucí",
    "label.email_confirmation": "Potvrzovací email",
    "table.registration_date": "Datum registrace",
    "label.next_bagde_level_is": "Makej dál a získej úroveň",
    "notifications.role_has_been_removed": "Role odstraněna",
    "button.move": "Přesunout",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "Detail",
    "table.award_unit": "Místní centrum",
    "sidebar.settings": "Nastavení",
    "dashboard.leader_state": "Vedoucí podle stavu",
    "CL_MESSAGE_TYPES.PRAISE": "Komentář",
    "notifications.award_unit_has_been_approved": "Vedoucí byl schválen",
    "states.awaiting_approval": "Čeká na schválení",
    "table.level": "Úroveň",
    "table.action_requested": "Požadovaná akce",
    "label.organisation_mode": "Typ organizace",
    "label.no_note": "Žádna poznámka",
    "tabs.my_events": "Mé akce",
    "notifications.participants_have_been_added": "Účastníci byli přidáni",
    "tabs.registration_questions": "",
    "button.delete_registration": "Smazat registraci",
    "notifications.parental_consent_link_has_been_sent": "Potvrzení rodiče bylo odesláno",
    "moduleTitle.select_role_organization": "Vybrat roli & organizaci",
    "label.experience": "Zkušenosti",
    "translationsManagement.modal.title": "Chcete aktualizovat překlady?",
    "table.ic": "IC",
    "table.id": "ID",
    "label.notify_email_explanation": "",
    "participant.would_you_like_to_remove": "Chcete smazat tento účet?",
    "table.fields_included": "",
    "label.user_guide_web_leader": "Návod k webu - vedoucí",
    "label.journey_type": "Typ expedice",
    "button.setup": "Nastevení",
    "tabs.my_national_office": "Mé národní centrum",
    "notifications.training_has_been_removed": "Trénink byl odstraněn",
    "label.nominated_and_identified_persons": "Autorizované osoby, které mohou vidět data, ale nemohou je upravovat",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Byli jste odhlášeni z důvodu neaktivity",
    "states.award_leader_signoff": "Schválení vedoucím",
    "table.award_signoff_attempts": "Pokusy o schválení",
    "sidebar.regions": "Regiony",
    "label.activity_deleted_note": "Aktivita smazána. Můžeš ji obnovit kliknutím na tlačítko níže.",
    "table.total": "Celkem",
    "errors.a_problem_has_occured_during_processing": "Během zpracování nastal problém, více informací zde",
    "participant.participant_already_has_gold_award": "Účastník již získal zlatou úroveň",
    "pageTitle.mro": "Mé regionální centrum",
    "notifications.authorization_code_has_expired": "Autorizační kód expiroval",
    "moduleTitle.child_organization_labels": "Štítek místního centra",
    "aj.aj_events": "Expedice",
    "global.loading": "Načítání",
    "label.gnipp": "",
    "sidebar.registrations": "Registrace",
    "label.any_string": "Žádný string",
    "contact.change_contact_status": "Změnit stav kontaktu",
    "tabs.registration": "Registrace",
    "label.override_payment_note": "Přepsat poznámku platby",
    "notifications.section_has_been_signed_off": "Oblast schválena",
    "label.payment_date": "Datum platby",
    "button.approve": "Schválit",
    "moduleTitle.loggin_in": "Přihlašování",
    "label.website": "Webové stránky",
    "label.role": "Role",
    "table.assessor_report": "Zpráva hodnotitele",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "Předchozí práce hodnotitele",
    "pageTitle.registrations": "Registrace",
    "tabs.my_messages": "Odeslané Zprávy",
    "parentalConsent.this_form_must_be_completed": "Tento formulář <strong> musí </strong> vyplnit rodič/opatrovník u účastníků, kterým nebylo <strong> 18 let</strong> a více.",
    "button.apply": "Aplikovat",
    "errors.include_at_least_one_number": "Obsahuje alespoň 1 číslici",
    "label.content_restore": "Obnovovací akce",
    "logs.hour": "hodina",
    "parentalConsent.i_have_read_and_understand": "7. Četl(a) jsem poskytnuté informace, a rozumím všem rozdílným úrovním a požadavkům programu DofE tak, jak je popsáno na webových stránkách: https://www.dofe.cz/o-programu.",
    "notifications.award_was_deleted": "",
    "label.journey_category": "Úroveň expedice",
    "notifications.search_cancelled": "Vyhledávání bylo přerušeno, je třeba počkat až doběhne.",
    "route.detail": "Detail",
    "route.user_guide": "Návod",
    "moduleTitle.history": "Historie",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Nepřiřazení účastníci",
    "states.inactive": "Neaktivní",
    "pageTitle.search_results": "Výsledky hledání",
    "button.proceed_to_login": "Připojuje se",
    "pageTitle.assessor_report_reject": "Oprava zprávy hodnotitele",
    "notifications.contact_has_been_removed": "Kontakt odstraněn",
    "sidebar.operating_authorities": "Zastřešující organizace",
    "label.no_note_from_participant": "",
    "aj.preparation_and_training": "Příprava a trénink",
    "route.user_guide_web_leader": "Návod k webu - vedoucí",
    "label.position_in_organization": "Pozice v organizaci",
    "CL_MESSAGE_TYPES.MESSAGE": "Zpráva",
    "errors.emails_dont_match": "Emaily se neshodují",
    "route.my_participants": "Můj účastník",
    "pageTitle.customisations": "Customizace",
    "tabs.localization_files": "Lokalizační složky",
    "table.assessor_approval": "Schválení hodnotitele",
    "tabs.related_contacts": "Související kontakty",
    "table.aus": "Místní ",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "Možné hodnoty",
    "label.if_your_download_doesnt_start": "Pokud se stahování nezahájí automaticky, klikněte zde",
    "route.independent_award_centres": "Nezávislé místní cetnrum",
    "pageTitle.user_guide": "Návody",
    "button.visit": "",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "Má organizace - detail",
    "pageTitle.nao_detail": "Národní centrum - detail",
    "button.change": "Změnit",
    "award.aj": "Expedice",
    "table.award_state": "Stav úrovně",
    "pageTitle.tasks_award_signoff": "Národní centrum schválení",
    "pageTitle.regions": "Regiony",
    "notifications.award_has_been_signed_off": "Úroveň schválena",
    "dashboard.award_approved_by": "Úrovně dokončeny - podle úrovně v 2016",
    "tabs.new_template": "Nový vzor",
    "error.parent_email_must_be_filled": "Je třeba ještě zadat e-mail rodiče",
    "label.organisation_invoicing_name": "Jméno pro fakturaci",
    "pageTitle.related_contacts": "Související kontakty",
    "button.try_again": "Zavřít upozornění a zkusit znovu",
    "label.cannot_be_change_to_another": "Nemůže být změněno na jinou úroveň",
    "notifications.lead_coordinator_has_been_set": "Nový vedoucí koordinátor byl nastaven",
    "label.training_name": "Název školení",
    "moduleTitle.new_contact": "Nový kontakt",
    "translationsManagement.modal.updateTitle": "Jste si jistí?",
    "moduleTitle.offline_award_units_signoff": "Schválení offline Ceny od vedoucího",
    "notifications.award_level_has_been_changed": "Úroveň byla změněna",
    "label.subject": "Předmět",
    "route.silver_level": "Stříbrná úroveň",
    "label.privacy_notice": "",
    "label.switch_organization": "Přepnout organizaci",
    "meta.dofe_name": "Mezinárodní cena vévody z Edinburghu",
    "route.profile": "Profil",
    "roles.super_user": "Super-uživatel",
    "dashboard.while_you_were_gone": "Mezitím co jsi byl pryč",
    "label.no_note_from_award_leader": "",
    "label.middle_name": "Prostřední jméno",
    "moduleTitle.new_activity": "Nová aktivita",
    "organisation.would_you_like_to_remove": "Přejete si odstranit tuto organizaci? ",
    "label.state_province": "Region",
    "moduleTitle.your_home_address": "Vaše adresa",
    "tabs.sign_offs": "Schválení",
    "moduleTitle.logs": "Záznamy",
    "button.view_more": "Více",
    "label.profile": "Profil",
    "label.title": "Oslovení",
    "tabs.award_signoff": "Schválení úrovně",
    "label.post_code": "PSČ",
    "states.ceremony_certificate": "Po ceremonii",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. Souhlasím s poskytnutím jakýchkoli osobních informací, které jsem jako rodič / opatrovník poskytl (včetně údajů o účastnících), provozovateli DofE a místnímu centru DofE. Souhlasím s tím, aby se s těmito informacemi zacházelo v souladu s ustanoveními a zásadami ochrany osobních údajů příslušného provozovatele DofE (v platném znění), a veškerými dalšími zákony, normami, pokyny nebo pokyny týkajícími se soukromí, které jsou pro ně závazné, v souladu s právními předpisy o ochraně soukromí.",
    "label.user_guide_web_participant": "Návod k webu - účastník",
    "label.award_unit_type": "Typ místního centra",
    "states.complete": "",
    "table.participant_state": "Stav účastníka",
    "pageTitle.my_organization_payment": "Má organizace - platba",
    "table.approved": "Schváleno",
    "pageTitle.my_organization_contacts": "Má organizace",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "Změnit <strong>{state}</strong> na?",
    "label.integer": "Celek",
    "notifications.translationUpdateInterrupted": "Selhalo nahrání překladů",
    "notifications.password_has_been_changed": "Heslo změněno",
    "button.invite_assessor": "Pozvat hodnotitele",
    "label.other_activity": "Další aktivita",
    "notifications.parental_consent_has_been_sent": "Souhlas rodiče/opatrovníka byl odeslán",
    "button.revise": "Opravit",
    "errors.end_date_must_be_after_start_date": "Datum ukončení by měl být pozdější než datum zahájení",
    "label.award_leader_signoff_date": "Datum schválení vedoucího",
    "parentalConsent.i_understand_every_participant_must": "8. Rozumím, že každý účastník DofE se programu musí účastnit v rámci Místního centra DofE, které má podle vlastního uvážení možnost přijmout, nebo odmítnout účastníky a jejich navrhované aktivity, které mají být v rámci DofE vykonávány.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "Expedice",
    "global.day": "Den",
    "moduleTitle.coordinator": "Koordinátor",
    "label.region": "kraj",
    "button.add_history_record": "Vlož historický záznam",
    "moduleTitle.adventurous_journey_template_settings": "Nastavení šablony expedice",
    "notifications.personal_details_have_been_updated": "Osobní údaje aktualizovány",
    "sidebar.ics": "ICs",
    "table.independent_award_centre": "Nezávislé místní centrum",
    "label.undelivered_mail_reason": "",
    "table.utc_date_time": "UTC čas",
    "moduleTitle.emails": "Emaily",
    "label.backoffice": "Web pro vedoucí a NAO",
    "moduleTitle.parent_consent": "Souhlas rodiče/opatrovníka",
    "label.photo_consent_given": "Souhlasím s využitím fotografií za účelem propagace",
    "moduleTitle.authorising_contact": "Autorizující kontakt",
    "label.assessment_with_role": "Hodnocení",
    "dashboard.type_of_awards": "Typ místního centra",
    "moduleTitle.payment": "Platba",
    "states.in_progress": "Probíhá",
    "table.recipient_first_name": "Křestní jméno",
    "logs.no_logs": "Žádné záznamy",
    "sidebar.my_office": "Mé centrum",
    "moduleTitle.message_title": "Zpráva",
    "label.assessor_report": "Zpráva hodnotitele",
    "notifications.rp_has_been_signed_off": "Rezidenční projekt schválen.",
    "tabs.labels": "Štítky",
    "sidebar.payments": "Platby",
    "meta.profile_questions": "Profilové otázky",
    "label.fax": "Fax",
    "label.email_help_custom_link": "",
    "label.last_name": "Příjmení",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "label.message_status": "Stav zprávy",
    "dashboard.participant_by_level": "Účastníci podle úrovně",
    "tabs.award_leaders": "Vedoucí",
    "label.i_confirm_that_ive_witnessed": "Potvrzuji, že jsem viděl účastnickou knihu pro následující aktivity.",
    "table.lead_coordinator": "Hlavní koordinátor",
    "states.deleted": "Smazáno",
    "label.no_answers": "Žádná odpověď",
    "button.add": "Přidat",
    "label.exchequer_number": "",
    "label.waiting": "Čekání",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "Oprava registrace",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "Souhlas rodiče/opatrovníka",
    "table.assessor_approve": "Schválení hodnotitele",
    "errors.some_fields_requires_your_attention": "Některé oblasti ještě vyžadují Tvou pozornost",
    "aj.qualifying_journey": "Ostrá expedice",
    "route.awards": "Úrovně",
    "table.registration": "Registrace",
    "pageTitle.assessors": "Hodnotitel",
    "notifications.award_has_been_updated": "Úroveň byla aktualizována",
    "errors.must_be_one_of": "Musí být jeden z {enums}",
    "pageTitle.logs": "Záznamy",
    "notifications.notifications.invitation_has_been_sent": "Pozvánka byla odeslána",
    "route.national_offices": "Národní centrum",
    "notifications.training_has_been_updated": "Trénink aktualizován",
    "label.parent_last_name": "Přijmení rodiče/opatrovníka",
    "table.leaders": "Vedoucí",
    "states.award_level_complete": "Dokončení úrovně",
    "button.reset": "Reset",
    "sidebar.my_award_unit": "Mé místní centrum",
    "pageTitle.all_aj_events": "Všechny expedice",
    "label.activity": "Aktivita",
    "moduleTitle.are_you_sure": "Jste si jistí?",
    "route.gold_level": "Zlatá úroveň",
    "table.evidence": "Závěrečná zpráva",
    "label.delivery_confirmed": "Doručení potvrzeno",
    "parentalConsent.as_the_parent": "Souhlasím, aby se účastník zapojil/a do sběru dat (např. dotazník spokojenosti s programem, SROI) pod hlavičkou organizace DofE za účelem datové analýzy, která je v souladu se strategií a cílem programu DofE.",
    "table.message_type": "Typ zprávy",
    "label.awardMode.offline": "Offline",
    "tasks.approve_registration": "Schválená registrace",
    "note.change_the_email_will_change": "Poznámka: Změna emailu změní také přenesený email",
    "notifications.participant_has_been_approved": "Účastník schválen",
    "label.reached_activity_limit": "Limit aktivity v této sekci aktivity dosáhnut. Účastník může mít v každé sekci maximálně tři aktivity.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "Štítek byl upraven.",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Příprava a trénink odstraněn",
    "pageTitle.settings": "Nastavení",
    "participant.level_registration_date": "{hodnota} Datum registrace",
    "notifications.question_has_been_removed": "Otázka odstraněna",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "Vedoucí",
    "notifications.participants_have_been_transferred": "Účastníci byli přesunuti",
    "tabs.assessors": "Hodnotitel",
    "sidebar.dashboard": "Úvodní deska",
    "pageTitle.independent_award_centers": "Nezávislá místní centra",
    "label.search": "Hledat",
    "moduleTitle.office_labels": "Štítky NC",
    "label.note_from_participant": "Poznámka od účastníka",
    "errors.required_field": "Požadované pole",
    "tasks.approve_task": "Schválení úkolu",
    "logs.edit_log": "Upravit záznam",
    "table.state": "Stav",
    "moduleTitle.level_summary": "Shrnutí úrovně",
    "moduleTitle.guides": "",
    "modal.close": "Zavřít",
    "label.parent_first_name": "Jméno rodiče/opatrovníka",
    "parentalConsent.i_understand_that_the_participant": "1. Chápu, že se účastník nemůže účastnit DofE, dokud nebude tento formulář dokončen (včetně souhlasu rodiče opatrovníka) a vrácen příslušnému zadavateli s příslušným registračním poplatkem a poté byl přijat Místním centrem DofE.",
    "tabs.award_units": "Místní centra",
    "table.hours": "Hodiny",
    "label.type": "Typ",
    "notifications.adventurous_journey_has_been_removed": "Expedice odstraněna",
    "label.aj_is_not_approved_yet": "Expedice zatím není schválena",
    "roles.authorizing_contact": "Autorizující kontakt",
    "table.date_submitted_to_office_signoff": "Datum odevzdání k potvrzení Národnímu centru",
    "notifications.section_has_been_returned": "Sekce byla opravena",
    "table.created_by": "Vytvořeno",
    "route.user_guide_web_participant": "Návod k webu - účastník",
    "route.templates": "Vzory",
    "states.awaiting_sign_off": "Schválení vedoucím",
    "table.phone": "Telefon",
    "label.parental_consent": "Souhlas rodiče",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "Bronzová úroveň",
    "label.invoice_currency": "Měna na faktuře",
    "button.new_label": "Nový štítek",
    "error.server_cannot_be_reached_at_the_moment": "Server je momentálně nedostupný. Akci zopakujte prosím později.",
    "notifications.contact_has_been_created": "Kontakt vytvořen",
    "pageTitle.profile_questions": "Profilové otázky",
    "table.observation_files": "Složky pozorování",
    "table.participants": "Účastníci",
    "tasks.no_evidence": "Neposkytnuta závěrečná zpráva",
    "table.recipient_message_types": "Typy zpráv",
    "label.allow_log_after_25_yo": "",
    "button.edit": "Upravit",
    "moduleTitle.leader": "Vedoucí",
    "notifications.new_template_has_been_updated": "Nový rozhovor aktulizován",
    "table.name": "Jméno",
    "label.no_results": "Žádné výsledky",
    "moduleTitle.documents": "Dokumenty",
    "button.invite": "Pozvat",
    "label.goal": "Cíl",
    "pageTitle.nao_award_units": "Národní centrum - Mísní centra",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "Alespoň {délka} znaků dlouhé",
    "label.email_help_note": "",
    "label.person_status.activating": "",
    "moduleTitle.remove_role": "Odstranit roli?",
    "table.message_read_at": "Přečteno",
    "label.total": "Celkem",
    "label.delete_participant_award_info": "",
    "route.leaders": "Vedoucí",
    "table.start_date": "Začátek",
    "moduleTitle.coordinators": "Koordinátoři",
    "button.create": "Vytvořit",
    "tabs.awards": "Úrovně",
    "label.congratulation": "Gratulujeme!",
    "parentalConsent.form_has_been_sent": "Souhlas rodiče/opatrovníka odeslán.",
    "states.journey_approval": "Expedice schválena",
    "pageTitle.reports": "Reporty",
    "table.journey_type": "Typ expedice",
    "label.yes": "Ano",
    "pageTitle.assessor_report": "Zpráva hodnotitele",
    "label.organization": "Organizace",
    "notifications.award_leader_has_been_updated": "Vedoucí byl aktualizován",
    "moduleTitle.edit_role": "Upravit roli",
    "table.journey_activity": "Aktivita expedice",
    "label.location": "Lokalita",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "Expedice",
    "global.assessor": "Hodnotitel",
    "moduleTitle.profile_questions": "Profilové otázky",
    "activity.cannot_edit_activity_if_award_in_state": "Nelze editovat aktivitu pokud má cena speciální {state} stav",
    "moduleTitle.assessor_detail": "Detail hodnotitele",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Rozumím, že účastník získá přístup k online záznamové knize (ORB) po přijetí do Místního centra DofE. Účastník si přečte požadavky DofE obsažené v záznamové knize nebo ORB před zahájením činnosti na zvolené úrovni. Chápu, že místní centrum DofE má právo rozhodnout, zda byly splněny požadavky pro udělení certifikátu, ať už bronzového, stříbrného nebo zlatého. Chápu, že provozovatel programu DofE může poskytnout účastníkům jen omezené pojištění v souvislosti s osobním úrazem, pojištěním odpovědnosti a pojištěním občansko-právní odpovědnosti, které se datují od momentu schválení registrace účastníka do DofE v rámci místního centra DofE. Odpovědnost za získání a udržení osobního úrazového pojištění nese účastník a jeho rodič / opatrovník.",
    "notifications.award_has_been_returned": "Úroveň opravena",
    "CL_BADGE_LEVEL_TYPES.APPRENTICE": "Učeň",
    "label.code_of_conduct": "",
    "button.new_contact": "Nový kontakt",
    "tabs.payments": "Platby",
    "roles.naa_oa_staff": "Zaměstnanec Národního centra",
    "label.switch_organisation_hint": "Toto menu můžete vyvolat kdykoliv volbou \"Přepnout organizaci\" z pravého horního menu",
    "label.expiration_date": "Datum vypršení",
    "tabs.participants": "Účastníci",
    "table.practice": "Cvičná",
    "notifications.one_activity_has_to_remain": "Jedna aktivity v oblasti musí zůstat nesmazána",
    "label.qualifications": "Kvalifikace",
    "states.organization_approval": "Schválení organizace",
    "label.available_badges_desc": "Jaké další odznaky a úrovně můžeš získat? Koukni se na přehled",
    "errors.must_be_an_integer": "Musí být číslo",
    "participant.send_confirmation_email_again_question": "Poslat potvrzovací email znovu?",
    "button.dismiss": "Zavřít",
    "table.advice": "",
    "label.years_of_working_experience": "Počet let praxe",
    "tabs.all_messages": "Všechny zprávy",
    "notifications.search_failed": "Během hledání se vyskytla chyba. Opakujte později. ",
    "notifications.changes_have_been_saved": "Změny byly uloženy",
    "label.just_become": "Právě jsi získal odznak za",
    "moduleTitle.resend_parental_consent_link": "Přeposlat odkaz na schválení rodiče",
    "label.activity_type": "Typ aktivity",
    "label.change_award": "Změna úrovně",
    "label.email": "Email",
    "button.remove": "Odstranit",
    "button.download": "Stažení",
    "label.vat_treatment": "DPH",
    "pageTitle.aj_template_new": "Nový vzor expedice",
    "table.per_page": "Na stránku",
    "notifications.translations_has_been_updated": "Překlady byly aktualizované",
    "notification.award_mode_has_been_updated": "Mód Ceny byl aktualizován",
    "tasks.revise_item": "Oprava položky",
    "button.resend_parental_consent": "Přeposlat potvrzení rodiče",
    "table.weeks_completed_required": "Týdny dokončeny/požadovány",
    "label.last_modified": "Poslední úpravy",
    "table.major": "Hlavní",
    "label.vat_number": "IČO",
    "errors.passwords_dont_match": "Hesla se neshodují",
    "table.country": "Země",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "Otázka aktualizována",
    "table.participant_name": "",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "Autorizační kód již není platný",
    "errors.must_be_no_more_than": "Musí být více než (value) znaků",
    "notifications.event_has_been_rejected": "Akce byla opravena",
    "tabs.customizations": "Customizace",
    "label.name_organization": "Jméno",
    "button.add_log": "Přidat záznam",
    "moduleTitle.invite_assessor": "Pozvat hodnotitele",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "Všichni účastníci budou přesunuti k novému vedoucímu",
    "table.recipient_last_name": "Příjmení",
    "moduleTitle.message_recipients": "Příjemci",
    "label.repeat_email": "Opakovat email",
    "errors.email_or_phone_required": "",
    "notifications.role_has_been_updated": "Role byla aktualizována",
    "roles.if_staff_stat_user": "IAF Statický uživatel",
    "participant.delete_account": "Smazat účet",
    "moduleTitle.would_you_like_to_remove_this_log": "Chcete odstranit tento záznam?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "Kategorie expedice",
    "sidebar.manual_data_import": "",
    "label.created_after_date": "Vytvořen po",
    "route.my_organization": "Má organizace",
    "button.show_list": "Zobrazit seznam",
    "label.leaders": "Vedoucí",
    "notifications.log_has_been_modified": "Záznam byl změněn",
    "button.upload_file": "Nahrát dokument",
    "moduleTitle.which_section_do_you_want_to": "Jakou oblast chce vrátit k \"probíhající\"?",
    "tabs.bronze_level": "Bronzová úroveň",
    "notifications.participants_have_been_saved": "Účastnici byli uloženi",
    "pageTitle.aj_template_detail": "Expedice",
    "label.parent_email": "Email rodiče/opatrovníka",
    "map.appr_location": "Přibližná adresa",
    "notifications.log_has_been_removed": "Záznam odstraněn",
    "notifications.label_has_been_assigned": "Štítek byl přiřazen.",
    "pageTitle.tasks_undelivered_emails": "Nedoručené emaily",
    "button.stay": "Zůstat",
    "table.previous_level": "Předchozí úroveň",
    "label.award_start_date": "Datum zahájení",
    "assessor_report.returned_to_participant": "Vrátit se k účastnikovi",
    "pageTitle.tasks_assessors_registration": "Registrace hodnotitele",
    "aj.cannot_modify_award": "Nemůžete změnit úroveň pokud je účastník přiřazen k expedici.",
    "moduleTitle.lost_internet_connection": "Vypadá to na ztrátu internetového připojení",
    "table.message_sent_by": "Odeslal",
    "states.ceremony": "Po ceremonii",
    "participant.reactivate_account": "Reaktivovat účet",
    "moduleTitle.send_message_bulk": "Odeslat zprávu {itemCount} účastníkům.",
    "label.birthdate": "Datum narození",
    "pageTitle.assessment_send_successfully": "Zhodnocení úspěšně odesláno",
    "states.assessor_approval": "Schválení hodnotitele",
    "award.change_award_level": "Změnit úroveň",
    "label.url_no_longer_valid": "Tato adresa je neplatná",
    "button.update": "Aktualizovat",
    "label.secondary_email": "druhý e-mail",
    "button.role_edit": "Upravit",
    "table.award_leader": "Vedoucí",
    "label.level": "Úroveň",
    "tasks.evidence": "Závěrečná zpráva",
    "notifications.participant_is_already_in_list": "Účastník je již na seznamu",
    "button.clear": "Zrušit",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "Výběr aktivit",
    "CL_BADGE_LEVEL_TYPES.HERO": "Hrdina",
    "table.activity": "Aktivita",
    "label.copy_to_clipboard": "{text} byl zkopírován do schránky.",
    "route.award_units": "Místní centra",
    "button.upload_photo": "Nahrát obrázek",
    "table.hours_completed_required": "Dokončeno/požadováno",
    "table.first_name": "Jméno",
    "notifications.adventurous_journey_has_been_returned": "Expedice byla opravena",
    "pageTitle.national_offices": "Národní centrum",
    "notifications.you_have_been_logged_in": "Jste přihlášení",
    "logs.offline": "",
    "moduleTitle.add_role": "Přidat roli",
    "label.user_app_guide_participant": "Návod k app - účastník",
    "notifications.file_has_been_removed": "Soubor odstraněn",
    "label.send_message": "Odeslat zprávu",
    "button.select": "Vybrat",
    "label.reason_of_deletion": "Důvod vymazání",
    "label.user_guide": "Návod",
    "pageTitle.nao_participants": "Národní centrum - účastníci",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Nahráno",
    "tasks.approve_item": "Schválení položky",
    "tasks.restore_participant_registration": "Obnovit registraci účastníka? ",
    "label.awardMode.hybrid": "Kombinované",
    "table.first_activity_started": "První aktivity",
    "moduleTitle.dates": "Data",
    "table.no_results": "Žádné výsledky",
    "states.registration_approval": "Schválení registrace",
    "table.breakdown_of_hours": "Rozpis hodin",
    "pageTitle.tasks_registration": "Registrace účastníka",
    "button.create_new": "Vytvořit nový",
    "sidebar.todolist": "To Do List",
    "label.active_participants": "Aktivní účastníci",
    "moduleTitle.postalAddress": "",
    "tasks.return_task": "Oprava úkolu",
    "organisation.change_organisation_state": "Změnit stav organizace",
    "moduleTitle.roles": "Role",
    "label.no_config_key_available": "Pro tuto sekci nejsou žádné konfigurační klíče",
    "placeholder.selectLanguage": "Vybrat jazyk",
    "moduleTitle.send_message": "Odeslat zprávu, komentář, nebo pochvalu k tomuto záznamu",
    "states.office_signoff": "Schválení Národním centrem",
    "notifications.translations_has_been_updated.failure": "Selhalo nahrání překladů",
    "logs.minute": "minuta",
    "label.last_activity": "Poslední aktivita",
    "sidebar.user_guide": "Návody",
    "table.message_subject": "Předmět",
    "label.trained_award_leader": "trénovaný vedoucí",
    "table.progress": "Pokrok",
    "table.suboperating_authorities": "Kraj",
    "activity.cannot_edit_activity_offline": "Tento účastník je v režimu Offline. <br><br>\nAktivity, Expedici ani residential project nelze editovat v případě offline modu.",
    "label.user_does_not_have_permissions": "Uživatel nemá povolení vidět tento obsah",
    "notifications.assessor_has_been_approved": "Hodnotitel bych schválen",
    "route.activity_approval": "Schválení aktivity",
    "moduleTitle.role": "Role",
    "button.run": "Probíhá",
    "label.to": "Komu",
    "notifications.file_has_been_updated": "Soubor aktualizován",
    "moduleTitle.edit_coordinator": "Změnit koordinátora",
    "sidebar.message_center": "Centrum zpráv",
    "notifications.authorization_code_is_no_longer_valid": "Autorizační kód již není platný",
    "button.reject": "Opravit",
    "label.label.participant_status": "Stav účastníka",
    "table.message_content": "Zpráva",
    "award.gold_level": "Zlatá úroveň",
    "sidebar.variables": "Variability",
    "parentalConsent.checkbox_copy": "Potvrzuji, že jsem rodič/opatrovník {firstName} {lastName}. Souhlasím s tím, že se účastní DofE v {organisationName} pod vedením vyškoleného vedoucího. Četl jsem, chápu  a souhlasím s požadavky a podmínkami účasti v DofE, jak je popsáno výše, a na internetových stránkách provozovatele DofE.",
    "button.go_to_dashboard": "Jít na úvodní desku",
    "button.add_option": "Přidat možnost",
    "label.is_completed": "Dokončeno",
    "pageTitle.award_units": "Místní centra",
    "states.completed": "Dokončeno",
    "button.adventurous_journey_template_settings": "Nastavení šablony expedice",
    "label.system_rights": "Pravidla systému",
    "label.assessor_assesstment_award_start_date": "",
    "label.update_translation_question": "",
    "button.login": "Přihlášení",
    "label.name_of_the_unit": "Název místního centra",
    "button.send": "Poslat",
    "award.ajs": "Expedice",
    "meta.payments_expired": "Platby - expirovány",
    "label.age": "Věk",
    "notifications.payment_info_updated": "Platební informace byly aktualizovány",
    "table.is_completed": "Dokončeno",
    "tabs.sent_messages": "Odeslané zprávy",
    "table.invited_by": "Den pozvání",
    "route.files": "Dokumenty",
    "route.assessors": "Hodnotitel",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "Moji účastníci",
    "label.change_leader_status": "Změnit status vedoucího",
    "moduleTitle.parent_consent_form": "Formulář souhlas rodiče/opatrovníka",
    "notifications.authorization_contact_has_been_set": "Autorizační kontakt odeslán",
    "button.close": "Zavřít",
    "label.independent_country": "Nezávislá země",
    "notifications.aj_preparation_training_has_been_returned": "Příprava a trénink expedice opravena",
    "route.history_log": "Historie záznamu",
    "participant.account_settings": "Nastavení účtu",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} protože",
    "label.orb_account": "",
    "notifications.file_url_is_not_specified_in_configuration": "URL souboru není v konfiguraci specifikováno",
    "notifications.award_unit_has_been_removed": "Místní centrum bylo odebráno",
    "table.parent": "Rodič",
    "label.mode_of_transport": "Způsob dopravy",
    "label.parental_consent_email_info": "Nezapomeňte zkontrolovat email vedoucího je dostupný a pošlete jej z detailu Ceny účastníka.",
    "label.current_award": "Současná úroveň",
    "table.action": "Akce",
    "pageTitle.suboperating_authorities": "Kraj",
    "notifications.award_leader_has_been_assigned": "Vedoucí byl přirazen",
    "tabs.sign_offs_locally": "Lokální schvalování",
    "Activity log has been restored": "Záznam aktivit byl obnoven",
    "sidebar.naos": "Národní centrum",
    "tabs.aj_templates": "Expedice vzory",
    "notifications.logging_out": "Odhlašování",
    "label.update_label": "Upravit štítek",
    "button.organisation_settings": "Nastavení organizace",
    "tabs.independent_award_centers": "Nezávislá místní centra",
    "label.current": "Data aktuální",
    "table.location": "Lokalita",
    "button.search": "Hledat",
    "notifications.aj_preparation_training_has_been_approved": "Příprava a trénink expedice schválena",
    "route.participants": "Účastníci",
    "label.other_location_information": "Další informace k lokalitě",
    "label.number_of_records": "Počet záznamů",
    "translationsManagement.infoLabel": "Tato funkcionalita umožňuje nahrát překlady z POEditoru.",
    "parentalConsent.i_consent_to_pay_all": "5. Souhlasím s placením všech poplatků a výdajů na lékaře, zdravotní sestry nebo nemocniční ubytování a výdaje vzniklé jménem účastníka v důsledku takové nehody, zranění, nemoci nebo ztráty, kterou utrpěl účastník při účasti nebo cestě do a z místa v rámci plnění DofE a veškerých aktivit spojených s DofE.",
    "label.nationality": "Národnost",
    "states.approval": "Schválení",
    "notifications.something_went_wrong": "Něco se pokazilo",
    "aj.practice": "Tréninková",
    "label.addressLine2": "Adresa 2",
    "label.please_leave_a_note": "Prosím zanechte poznámku",
    "placeholder.select": "Vybrat",
    "label.observations": "Pozorování",
    "label.aim": "Cíl",
    "label.addressLine1": "Adresa",
    "roles.aj_instructor": "Instruktor expedice",
    "meta.payments_waiting": "Platby - čekání",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "Instruktor",
    "moduleTitle.remove_customization_and_reset": "Vymazat hodnotu a nastavit konfiguraci na původní?",
    "notifications.participant_registration_has_been_restored": "Registrace účastníka byla obnovena",
    "organisation.change_award_unit_mode": "Změnit status organizace",
    "table.organization_type": "Typ organizace",
    "notifications.participant_has_been_deleted": "Účastník smazán",
    "label.language_settings": "Nastavení jazyka",
    "notifications.event_has_been_approved": "Projekt byl schválen",
    "label.password": "Heslo",
    "label.text": "Text",
    "table.observations": "Pozorování",
    "notifications.participant_has_been_created": "Účastník vytvořen",
    "table.note_for_al": "Poznámka pro vedoucího",
    "label.payment_confirmed": "Platba potvrzena",
    "label.previous_completed_award_level": "Předchozí úroveň (ne ORB)",
    "pageTitle.new_aj_event": "Nová expedice",
    "label.backend": "Emaily, notifikace, seznamy",
    "label.relationship_to_participant": "Vztah k účastníkovi",
    "award.physical_recreation": "Pohyb",
    "contact.collect_emails": "Vybrat adresy pro hromadnou zprávu",
    "moduleTitle.assessor_report_reject": "Odmítnutí",
    "CL_BADGE_LEVEL_TYPES.MASTER": "Mistr",
    "label.supervisor_report": "Zpráva školitele",
    "table.role": "Role",
    "OTHER.notification.praise.description": "Komentář k Tvému záznamu {0} z {1}.",
    "route.user_guide_web_nao": "Návod k webu - NAO",
    "label.page_not_found": "404 - Stránka nenalezena",
    "table.labels": "Štítky",
    "notifications.file_has_been_uploaded": "Soubor nahrán",
    "moduleTitle.address": "Adresa",
    "moduleTitle.lead_coordinator": "Hlavní koordinátor",
    "pageTitle.login": "Přihlášení",
    "label.frontoffice": "Web pro účastníky",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "Rezidenční projekt byl nastaven",
    "moduleTitle.award_unit": "Místní centrum",
    "button.remove_file": "Odstranit soubor",
    "moduleTitle.billing_address": "Fakturovací adresa",
    "pageTitle.my_aj_events": "Mé expedice",
    "route.tasks": "Úkoly",
    "button.confirm": "Potvrdit",
    "label.national_award_authority": "Národní centrum",
    "label.independent_award_centre": "Nezávislá místní centra",
    "award.generate_award_report": "Generovat report",
    "route.my_region_office_customization": "Mé regionální centrum - přizpůsobení",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "Žádost o změnu hesla poslána",
    "tabs.detail": "Detail",
    "participant.change_participant_status": "Změnit stav účastníka",
    "table.key": "API klíč",
    "label.find_address": "Najít adresu",
    "notifications.assessor_has_been_rejected": "Hodnotitel byl upraven",
    "label.transfer_participants": "Přesunout účastníky",
    "button.continue_to_payment_gateway": "Pokračovat na platební membránu",
    "notifications.participant_registration_has_been_removed": "Registrace účastníka byla odstraněna",
    "moduleTitle.page_not_found": "404 - Stránka nenalezena",
    "route.adventurous_journeys": "Expedice",
    "states.registration_assessment": "Registrace",
    "heading.change_award_unit_mode": "Změnit mód místního centra",
    "label.user_guide_web_nao": "Návod k webu - NAO",
    "tabs.silver_level": "Stříbrná úroveň",
    "table.paid_by": "Zaplaceno",
    "CL_MESSAGE_STATES.READ": "Přečtené",
    "label.your_report_has_been_successfully_sent": "Váš report byl úspěšně poslán.",
    "sidebar.my_organization": "Má organizace",
    "pageTitle.participants": "Účastníci",
    "notifications.preparation_training_has_been_updated": "Příprava a trénink byl aktualizován",
    "moduleTitle.server_is_unreachable": "Server je nedostupný",
    "label.last_activity_date": "Datum poslední aktivity",
    "award.bronze_level": "Bronzová úroveň",
    "moduleTitle.award_units": "Místní centrum",
    "table.completed": "Dokončeno",
    "moduleTitle.revise_message": "Opravit zprávu",
    "table.lastUsed": "Naposledy použito",
    "award.bronze_to_gold_level": "Bronzová úroveň na zlatou",
    "button.change_password": "Změna hesla",
    "label.nao_price": "Národní centrum- cena",
    "label.payment_state": "Stav platby",
    "label.wwc_expired": "WWC vypršelo",
    "label.award_office_signoff_date": "Datum schválení Národního centra",
    "label.award_unit": "Místní centrum",
    "award.gold_level_short": "Zlato",
    "moduleTitle.other_info": "Další informace",
    "table.note": "Poznámka",
    "label.search_by_email_first_or_last": "Hledání podle emailu, jméno nebo přijmení",
    "OTHER.notification.user.message": "Více se dozvíš v ORB aplikaci",
    "tabs.history": "Historie",
    "notifications.label_has_been_created": "Štítek byl vytvořen.",
    "tabs.unassigned_participants": "Nezařazení účastníci",
    "table.main_award_leader": "Hlavní vedoucí",
    "parentalConsent.i_as_the_parent": "3. Beru na vědomí, že některé činnosti jsou považovány za rizikové (lyžařské sporty, horské treky, horolezení apod.), a že rizikové aktivity nemusí být kryty pojistnými ujednáními DofE. Rozumím, že odpovědnost za všechna rizika vyplývající z účasti účastníka v DofE je pouze na účastníkovi. Činnosti a aktivity v rámci DofE si vždy stanoví účastník sám.",
    "label.state": "Stav",
    "notifications.award_leader_has_been_removed": "Vedoucí programu byl odstraněn",
    "tabs.organization_detail": "Detaily organizace",
    "table.operating_authorities": "Zastřešující organizace",
    "label.available_labels": "Dostupné štítky",
    "modal.select": "Vybrat",
    "tabs.expired_payments": "Expirované platby",
    "moduleTitle.note_for_al": "Poznámka pro vedoucího",
    "CL_BADGE_CATEGORY_TYPES.RP": "Rezideční projekt",
    "moduleTitle.confirm": "Potvrdit",
    "notification.new_activity_added": "Nová aktivita přidána",
    "notifications.award_leader_has_been_moved": "Vedoucí byl přesunut",
    "label.award_mode": "Typ účastníka",
    "label.phone": "Telefon",
    "notifications.organization_has_been_updated": "Organizace byla aktualizována",
    "moduleTitle.assessor": "Hodnotitel",
    "label.bulk_action_confirmation": "Potvrzení hromadné akce",
    "table.parent_approval": "Souhlas rodiče/opatrovníka",
    "label.date_of_delivery": "Datum doručení",
    "sidebar.assessors": "Hodnotitel",
    "label.journey_activity": "Aktivita Expedice",
    "award.inactive_award": "Neaktivní úroveň",
    "label.end_date": "Konec",
    "label.orb_testing": "",
    "label.no_activities": "Žádné aktivity",
    "moduleTitle.please_confirm": "Prosím potvrďte",
    "button.login_with_another_account": "Přihlásit se s jiným účtem",
    "tasks.reject_registration": "Oprava registrace",
    "label.submitted_after_date": "Odesláno po",
    "label.update_translations_successful": "",
    "button.assign_leader": "Přiřadit vedoucího",
    "table.already_running": "Již probíhá",
    "label.no": "Ne",
    "label.count_items_selected": "{count} položek vybráno",
    "label.secondary_phone_number": "druhé telefonní číslo",
    "label.my_experience": "Má zkušenost",
    "notifications.adventurous_journey_has_been_approved": "Expedice byla schválena",
    "pageTitle.mro_detail": "Mé regionální centrum - detaily",
    "moduleTitle.nao_specific_info": "Konkrétní údaje o Národním centru",
    "label.preparing_document_for_import": "Příprava dokumentů pro import",
    "tasks.observations": "Pozorování",
    "notifications.confirmation_email_has_been_sent": "Potvrzovací email odeslán",
    "button.restore": "Obnovit",
    "OTHER.PERSEVERANCE_MASTER_DESC": "{weekBlock} týdny v kuse.",
    "label.importing_file": "Nahrávání dokumentu",
    "label.or_dont_agree": "Nebo nesouhlasíš? Můžeš",
    "moduleTitle.award_leader": "Vedoucí",
    "label.me": "(já)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Stáhnout seznam",
    "organisation.move_award_unit": "Odstranit místní centrum",
    "label.file_category": "",
    "notifications.connecting_to_server": "Připojování k serveru",
    "parentalConsent.i_understand_that_a_and_b": "11. Beru na vědomí, že: <br /> a. Účastník nesmí řídit motorové vozidlo nebo přepravovat jiné účastníky, kteří se účastní činností souvisejících s DofE, pokud účastník nemá příslušný a platný řidičský průkaz, a pokud neexistuje vhodné pojištění třetí strany k pokrytí nákladů jakékoli osoby, která by byla zraněna v důsledku řízení vozidla daným účastníkem. <br /> b. Účastník nesmí být svezen žádnou osobou, která se neúčastní nebo nepomáhá při organizaci DofE za účelem účasti v DofE, aniž by daná osoba byla držitelem vhodného a platného řidičského průkazu, a aniž by existovalo vhodné pojištění třetí strany k pokrytí potřeb zraněné osoby v důsledku jízdy daného jednotlivce.",
    "table.reason": "",
    "pageTitle.contacts": "Kontakty",
    "states.award_leader_approval": "Schválení vedoucím",
    "meta.payments": "Platby",
    "label.suboperating_authority": "Kraj",
    "route.my_region_office": "Mé regionální centrum",
    "states.registration_not_approved": "Registrace nepovolena",
    "label.direct_entrant": "Přímý vstup",
    "tabs.all_participants": "Všichni účastníci",
    "tabs.payment": "Platba",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "Opakovat nové heslo",
    "label.other_roles": "",
    "logs.hours": "hodiny",
    "notifications.spreadsheet_has_been_imported_successfully": "",
    "label.bulk_action_question": "Chcete udělat hromadnou změnu u {count} položek?",
    "moduleTitle.personal_details": "Osobní detaily",
    "label.bulk_action_emailing": "",
    "route.my_events": "Mé události",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "Obsahuje velké a malé písmeno",
    "tabs.removed_participant_registrations": "Odstranit registraci účastníka",
    "sidebar.mynao": "Mé Národní centrum",
    "tabs.office_details": "Detaily centra",
    "label.major": "Hlavní",
    "tabs.documents": "Dokumenty",
    "label.new_password": "Nové heslo",
    "sidebar.adventure_journey": "Expedice",
    "pageTitle.customizations": "Customizace",
    "moduleTitle.assessor_report": "Report",
    "label.registration_date": "Datum registrace",
    "notifications.training_has_been_added": "Trénink přidán",
    "aj.qualifying": "Ostrá",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Byli jste odhlášeni z důvodu vypršení vaší session.",
    "award.service": "Dobrovolnictví",
    "notifications.rp_state_has_been_changed": "Stav Rezidenčního projektu byl změněn",
    "label.ctest_access": "",
    "table.created": "Vytvořeno",
    "tasks.revise_task": "Oprava úkolu",
    "button.assign": "Přiřadit",
    "button.return": "Opravit",
    "table.status": "Status",
    "button.restore_activity": "Obnovit aktivitu",
    "tabs.new_aj_event": "Nová expedice",
    "roles.if_staff_viewer": "IAF Jen pro čtení",
    "table.message_recipients": "Příjemci",
    "notifications.new_template_has_been_created": "Nový rozvrh vytvořen",
    "global.something_went_wrong": "Něco se pokazilo",
    "table.expire_day": "Den vypršení",
    "tabs.history_log": "Historie záznamu",
    "label.form_of_payment": "Způsob  platby",
    "button.add_training": "Přidat trénink",
    "label.par_reg_cust_note": "Tento seznam vám umožní přizpůsobit pole, která se zobrazují při registraci účastníka. Ovlivníte tak data, která shromažďujete. Pokud si přejete provést změny, kontaktujte prosím svou regionální kancelář – k provedení těchto změn má přístup pouze IAF Sys Admin.",
    "label.my_qualification": "Má kvalifikace",
    "button.add_new_profile_question": "Přidat novou profilovou otázku",
    "table.operating_authority": "Zastřešující organizace",
    "table.aim": "Cíl",
    "table.awards": "Ceny",
    "participant.deactivate_account": "Deaktivovat účet",
    "table.organization_name": "Organizace",
    "label.email_help_award_leader_first_name": "",
    "table.date": "Datum",
    "tasks.would_you_like_to_delete": "Chcete smazat tohoto účastníka?",
    "notifications.configuration_value_has_been_updated": "Konfigurační hodnota aktualizovaná",
    "ajTemplates.fill_from_template": "Vyplň ze vzoru",
    "contact.send_test_email": "Zaslat testovací email",
    "moduleTitle.aj_preparation_and_training": "Příprava a trénink expedice",
    "label.ce_be": "",
    "button.notify_participant": "",
    "CL_MESSAGE_STATES.UNREAD": "Nepřečtené",
    "label.parent_phone": "Telefonní číslo rodiče/opatrovníka",
    "label.nao_regulations": "",
    "award.skills": "Dovednost",
    "label.reject_application": "Odmítnut hodnocení",
    "leader.delete_account": "Smazat kontakt",
    "table.assign": "Přiřadit",
    "roles.aj_supervisor": "Školitel expedice",
    "label.logout": "Odhlášení",
    "moduleTitle.award_leader_edit": "Uprav vedoucího",
    "moduleTitle.training": "Trénink",
    "notifications.coordinator_has_been_removed": "Koordinátor byl odstraněn",
    "label.message_title": "Předmět zprávy",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Hlavní vedoucí/koordinátor",
    "label.bulk_action_successful": "{count} položek úspěšně změněno.",
    "tasks.clear_email_revision": "",
    "table.preparation": "Příprava",
    "table.delete": "Smazat",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Reporty",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "",
    "pageTitle.operating_authorities": "Operující autority",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "Potvrzeno",
    "notifications.invitation_has_been_sent": "Pozvánka poslána",
    "pageTitle.independent_countries": "Nezávislé země",
    "label.assessors_email": "E-mail hodnotitele",
    "tasks.approve_assessor_registration": "Schválit registraci hodnotitele",
    "table.award_duration": "Délka úrovně",
    "notifications.organization_has_been_moved": "Organizace byla odstraněna",
    "pageTitle.nao_payment": "Národní centrum - platba",
    "participant.history_log": "Historie záznamu",
    "label.rejected_with_note": "",
    "label.already_running": "Již probíhá",
    "button.continue": "Pokračovat",
    "award.no_data_to_show": "Žádná data k zobrazení",
    "participant.send_email_invitation_again_question": "Znovu poslat pozvánku emailem?",
    "label.reason_for_changing_assessor": "Důvod změny hodnotitele",
    "button.delete": "Smazat",
    "moduleTitle.requirements_and_conditions": "Požadavky a podmínky",
    "roles.leader": "Vedoucí",
    "label.if_download_doesnt": "Pokud stahování nezačne automaticky zkontrolujte že váš prohlížeč nezakázal otevření nového okna",
    "dashboard.your_todo_list": "Tvůj To Do List",
    "notifications.award_unit_has_been_returned": "Místní centrum bylo opraveno",
    "moduleTitle.participant_activities": "Aktivity účastníka",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "Aktivní vedoucí",
    "aj.preparation": "Příprava",
    "button.change_state": "Změnit stav",
    "label.current_password": "Současné heslo",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Nastavení kontaktu",
    "button.remove_photo": "Odstranit fotku",
    "notifications.activity_has_been_setup": "Aktivita byla nastavena",
    "errors.must_be_more_than": "Musí být více než (limit)",
    "table.goal": "Cíl",
    "notifications.coordinator_has_been_set": "Koordinátor nastaven",
    "OTHER.PERSEVERANCE_HERO_DESC": "{weekBlock} týdny v kuse.",
    "label.cc": "Kopie",
    "CL_BADGE_CATEGORY_TYPES.ACTIVITY": "Aktivita",
    "label.duration": "Doba trvání",
    "table.actions": "Akce",
    "participant.send_email_invitation_again": "Znovu poslat pozvánku emailem?",
    "CL_BADGE_CATEGORY_TYPES.AWARD": "Ocenění",
    "moduleTitle.would_you_like_to_remove_participant": "Chcete smazat účastníka?",
    "parentalConsent.i_authorise_employees": "4. Opravňuji zaměstnance nebo zástupce místních center DofE a další osoby, které se účastní, nebo se podílejí na organizaci programu DofE, aby pomohli v případě jakékoliv nehody, zranění, nemoci nebo ztráty účastníka v průběhu účasti v DofE, nebo v průběhu cestování do a z jakýchkoli činností nebo aktivit souvisejících s DofE. Uděluji oprávnění, aby účastník DofE získal jakoukoli potřebnou lékařskou pomoc nebo léčbu, včetně (ale bez omezení) zapojení jakýchkoli lékařů, zdravotních sester nebo pobytu v nemocnicích.",
    "button.reload_page": "Znovu načíst stránku",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "Email",
    "label.new_goal": "Nový cíl",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Nesprávný email",
    "pageTitle.new_contact": "Nový kontakt",
    "sidebar.gops": "",
    "button.manage_participants": "Spravovat účastníky",
    "errors.invalid_phone_format": "Nesprávné telefonní číslo",
    "notifications.login_details_have_been_changed": "Přihlašovací údaje změněny",
    "moduleTitle.participant_logs": "Záznamy účastníka",
    "label.save": "Uložit",
    "label.frequently_asked_questions": "Často kladené otázky (FAQs)",
    "label.city": "Město",
    "notifications.configuration_value_has_been_reset": "Konfigurační hodnota byla resetována",
    "states.office_sign_off": "Schválení Národním centrem",
    "button.save": "Uložit",
    "button.import_data_from_selected_file": "Importovat data z určeného dokumentu",
    "parentalConsent.i_understand_that_the_participant_cannot": "9.Beru na vědomí, že účastník nemůže zahájit žádnou konkrétní část DofE programu, pokud nejsem přesvědčen, že jakýkoli dobrovolník nebo hodnotitel je dostatečně zkušený a / nebo kvalifikovaný pro instruktáž / dohled nad / posuzování dané části programu DofE. A dokud příslušní dobrovolníci a hodnotitelé neukončí a neposkytnou požadovanou dokumentaci místnímu centru DofE.",
    "pageTitle.apiKeys": "API klíče",
    "label.international_region": "Mezinárodní region",
    "tabs.levels": "Úrovně",
    "tabs.additional_files": "Další dokumenty",
    "label.continuation_level": "Navazující úroveň",
    "label.message_type": "Typ",
    "table.adventurous_journey_detail": "Detail expedice",
    "button.set": "Nastavit",
    "label.i_certify_that_as_the_assessor": "Potvrzuji, že účastník v této aktivity splnil všechny požadavky.",
    "table.coordinator": "Koordinátor",
    "participant.send_confirmation_email_again": "Poslat potvrzovací email znovu?",
    "table.report": "Report",
    "label.update_translations_results": "",
    "table.observation_note": "Poznámka pozorování",
    "messages.message": "Zpráva",
    "label.view_more": "Více",
    "notifications.payment_link_has_been_reset": "Platební odkaz byl resetován",
    "table.type": "Typ",
    "moduleTitle.updateConfigurationKey": "Aktualizovat konfigurační klíč",
    "sidebar.independent_award_centers": "Nezávislá místní centra",
    "table.activity_type": "Typ aktivity",
    "label.awardMode.online": "Online",
    "table.data_state": "Poslední změna dat",
    "button.generate_report": "Vygenerovat report",
    "moduleTitle.assessed_by_award_leader": "Zhodnoceno vedoucím",
    "table.child_protection_number": "Číslo \"child protection\"",
    "button.bulk_change": "Hromadná změna",
    "label.send_welcome_email": "",
    "label.award_state": "Stav ceny",
    "moduleTitle.overview": "Přehled",
    "table.aj_detail": "Detail expedice",
    "pageTitle.tasks_activity_approvals": "Schválení aktivity",
    "label.section": "Sekce",
    "route.history": "Historie",
    "route.event_participants": "Události účastníků",
    "participant.account_detail": "Natavení účtu",
    "route.dashboard": "Úvodní deska",
    "table.payments": "Platby",
    "pageTitle.profile": "Profil",
    "organisation.remove_organisation": "Odstranit organizaci",
    "pageTitle.my_organization": "Má organizace",
    "label.award_leader": "Vedoucí",
    "notifications.assessor_has_been_updated": "Hodnotitel byl aktualizován",
    "label.participant_personal_reflection": "",
    "button.add_key": "Přidat klíč",
    "header.appMotto": "DUKE",
    "table.qualifying": "Ostrá",
    "button.upload": "Nahrát",
    "button.resend": "Znovu poslat",
    "label.filename": "Název souboru",
    "label.change_parental_consent": "",
    "button.cancel": "Zrušit",
    "label.aply_to_all_langs": "",
    "route.customization": "Customizace",
    "errors.minimal_duration_is": "Minimální doba trvání je 30 min",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "Stav účastníka",
    "award.bronze_level_short": "Bronz",
    "label.phone_type": "Druh telefonu",
    "global.night": "Noc",
    "button.adventurous_journey_settings": "Nastavení expedice",
    "participant.leader_must_be_selected": "Musí být zvolen vedoucí",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "Uživatel přidal přípravu a trénink",
    "table.approve": "Schválit",
    "label.role_in_organisation": "Role v organizaci",
    "states.finished": "Dokončeno",
    "label.created": "Vytvořeno",
    "button.back_to_home": "Zpátky domů",
    "label.options": "Možnosti",
    "contact.next_level_invitation": "Pozvání do další úrovně",
    "moduleTitle.activity_detail": "Detail aktivity",
    "route.section_signoff": "Schválení oblasti",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Nastavení kontaktu",
    "label.transation_id": "ID transakce",
    "notifications.activity_has_been_updated": "Aktivita byla aktualizována",
    "sidebar.awards": "Ceny",
    "parentalConsent.images_consent": "Jako rodič/opatrovník dávám souhlas k užití fotek a videí účastníka Mezinárodní cenou vévody z Edinburghu k účelům propagace programu a organizace.",
    "participant.would_you_like_to_delete": "Chcete smazat tento účet?",
    "roles.user": "Uživatel",
    "label.label": "Štítek",
    "label.select_sheet": "",
    "moduleTitle.badges": "Odznaky",
    "CL_BADGE_CATEGORY_TYPES.AJ": "Expedice",
    "global.no_results": "Žádné výsledky",
    "moduleTitle.address_line_2": "Adresa 2",
    "states.awaiting_office_sign_off": "Čeká na schválení centra",
    "moduleTitle.export": "Export",
    "moduleTitle.address_line_1": "Adresa 1",
    "notifications.participant_has_been_assigned": "Účastník byl přiřazen",
    "roles.viewer": "Pozorovatel",
    "label.participants_total": "Celkem účastníků",
    "errors.auth_code_is_no_longer_valid": "Autorizační kód je neplatný - již byl použit nebo vypršela jeho platnost",
    "label.file_is_not_available": "Soubor není dostupný",
    "button.select_template": "Vybrat vzor",
    "label.group_messages": "Seskupit zprávy",
    "label.payment": "Platba",
    "award.silver_level_short": "Stříbro",
    "table.participant_id": "",
    "text.hours_old": "{hours} hodin",
    "moduleTitle.your_personal_information": "Vaše osobní informace",
    "aj.minimum_date_recommendation": "Doporučená minimální doba trvání pro cvičnou expedici a {jméno} je",
    "label.date_of_payment": "Datum platby",
    "button.view": "Podívat se",
    "label.create_new_label": "Vytvořit nový štítek",
    "title.confirmation": "",
    "button.set_participants": "Nastavit účastníky",
    "roles.assessor": "Hodnotitel",
    "moduleTitle.coordinator_settings": "Nastavení koordinátora",
    "label.parent_relationship": "Vztah rodiče/opatrovníka",
    "table.nao": "Národní centrum",
    "notifications.email_has_been_sent": "E-mail byl odeslán",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "Kraj",
    "route.award": "Cena",
    "label.no_roles": "Žádné role",
    "table.files": "Složky",
    "aj.minimum_date_requirements": "Minimální požadovaná doba pro ostrou expedici a {name} je",
    "pageTitle.labels": "Štítky",
    "label.participant_is_semi_offline": "Participant je v režimu offline.",
    "moduleTitle.other_coordinators": "Ostatní koordinátoři",
    "button.updateSelectedLanguage": "Vybrat jazyk",
    "tasks.approve_award_registration": "Schválena registrace úrovně",
    "participant.invite_participant_to_next_level": "Pozvat účastníka do další úrovně? ",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Úrovně",
    "warning.award_marked_as_paid": "",
    "table.edit": "Opravit",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "Mezinárodní cena",
    "moduleTitle.after_assigning_a_role_to_yourself": "Po změně nebo přiřazení nové role se budete muset znovu přihlásit",
    "label.transaction_id": "ID Transakce",
    "table.suboperating_authority": "Kraj",
    "label.participant_survey": "Jako účastník souhlasím s účastí na dotaznících centrály DofE",
    "label.badge_to_achieve_count": "{weeksToAchieve} týdny do",
    "label.created_by": "Vytvořeno",
    "button.send_confirmation_email_again_question": "Znovu poslat potvrzovací email",
    "label.email_help_award_leader_email": "",
    "label.name": "Jméno",
    "tabs.gold_level": "Zlatá úroveň",
    "pageTitle.award_documents": "Dokumenty organizace",
    "label.online_payments": "Online platby",
    "label.child_protection_number": "",
    "participant.send_password_recovery_email": "Znovu poslat email s obnovou hesla?",
    "notifications.new_log_has_been_added": "Nový záznam přidán",
    "label.no_message": "Žádná zpráva",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Název organizace",
    "pageTitle.my_organization_templates": "Má organizace - vzory",
    "pageTitle.award_leaders": "Vedoucí",
    "label.status": "Status",
    "label.street": "Ulice",
    "roles.if_staff_superuser": "IAF Superuživatel",
    "table.licence_holder": "Držitel licence",
    "label.created_at": "Vytvořeno",
    "OTHER.notification.praise.title": "Nový komentář k Tvému záznamu",
    "table.section": "Sekce",
    "table.system_rights": "Pravidla systému",
    "label.iac_type": "IAC typ",
    "label.other": "Další",
    "moduleTitle.login": "Přihlášení",
    "label.no_data_to_show": "Žádná data k nahlédnutí",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Nelze změnit úroveň účastníka pokud již je přiřazen k expedici",
    "tabs.waiting_payments": "Čekající platby",
    "global.supervisor": "Školitel",
    "notifications.new_role_has_been_added": "Nová role byla přidána",
    "award.silver_level": "Stříbrná úroveň",
    "heading.change_awards_mode": "Změnit mód Ceny",
    "button.save_changes": "Uložit změny",
    "organisation.would_you_like_to_move_award_unit": "Kam chcete přesunout toto místní centrum?",
    "label.fields": "Štítek",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "Mé regionální centrum - detaily",
    "table.started_at": "Začátek",
    "parentalConsent.i_consent_to_the_award_unit": "2. Dávám souhlas místnímu centru DofE a všem dalším osobám, včetně dobrovolníků, kteří se podílejí na organizaci nebo pomáhají s programem DofE, dále dávám souhlas najatým řidičům dopravy s přepravou účastníka za účelem účasti na činnostech nebo úkolech spojených s DofE, podle potřeby (například expedice). Beru na vědomí, že místní centrum DofE mně předem informuje o tom, kdy a kde se taková cesta uskuteční.",
    "logs.minutes": "minuty",
    "label.total_participants": "Celkem účastníků",
    "moduleTitle.contact_info": "Kontaktní informace",
    "table.payment_link": "Odkaz na platbu",
    "errors.please_contact_your_local_award_staff": "Prosím, kontaktuj svého vedoucího"
}